import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "@mui/material/Tooltip";

const ExternalComponentsButton = () => {
  /**
   * This function set the display of the external souces to none or block
   */
  const toggleExternalWindow = () => {
    const externalWindow = document.getElementById("external-parent-group");
    const currentDisplayValue = window.getComputedStyle(externalWindow).display;

    if (currentDisplayValue === "none" || currentDisplayValue === "") {
      externalWindow.style.display = "block";
    } else {
      externalWindow.style.display = "none";
    }
  };

  return (
    <Tooltip
      title={
        <span style={{ fontSize: "14px" }}>
          <b>Show/Hide External Components</b>
        </span>
      }
      placement="right"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "rgba( 83, 139, 34, 0.9)",
            fontFamily: "Maven pro",
            padding: "5px 10px",
            "& .MuiTooltip-arrow": {
              color: "rgba( 83, 139, 34, 0.9)",
            },
          },
        },
      }}
    >
      <button className="layer-layer-show" onClick={toggleExternalWindow}>
        <FontAwesomeIcon icon={faPaperPlane} />
      </button>
    </Tooltip>
  );
};

export default ExternalComponentsButton;
